export default __webpack_public_path__ + "static/media/toh.2f44450c.png";